import * as React from 'react';
import cn from 'clsx';

import * as styles from '../styles.css';

interface ICardLayoutProps extends React.PropsWithChildren {
  isWrap?: boolean;
}

export const CardLayout: React.FC<ICardLayoutProps> = ({ isWrap, children }) => {
  return <div className={cn(styles['layout'], isWrap && styles['layout-wrap'])}>{children}</div>;
};
